module.exports = __webpack_public_path__ + "static/media/image.62fbdaf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/UnderstandYourMarketingData/image.jpg
// module id = 88
// module chunks = 0